import React from "react";
import { AtomicTextField } from "@adsk/acc-issues-common/components/primitive/AtomicTextField";
import { useFieldTestId } from "../../../utils/components/IssueFieldPresentationContext";
import { isAttributeEditable } from "../../../utils/data/entityPermissions";
import { useTextValidation } from "../../../utils/validation/validationUtils";
import { MAX_LOCATION_DETAILS_LENGTH } from "../../../utils/validation/entitySchemas";
import { Issue } from "@adsk/acc-issues-types";
import { useTranslations } from "@adsk/acc-issues-translations";
import { IssueChangeFn } from "./typesForFields";

// This Field is similar to the one in IssuesTab/TemplatesConfig/IssueTemplateDetailPanel/detail-panel-fields/...
// In case any necessary change is needed, it would be nice check on the other file as well
export const LocationDetailsField = ({
  T,
  handleChange,
  issue,
  required = false,
  viewOnly = false,
}: {
  T: ReturnType<typeof useTranslations>["T"];
  handleChange: IssueChangeFn;
  issue: Issue;
  required?: boolean;
  viewOnly?: boolean;
}) => {
  const testId = useFieldTestId("location-details-field");

  const validationSchema = useTextValidation({
    maxLength: MAX_LOCATION_DETAILS_LENGTH,
    isRequired: required,
  });

  const isDisabled = viewOnly || !isAttributeEditable(issue, "locationDetails");
  return (
    <div data-testid={testId}>
      <AtomicTextField
        fieldKey="locationDetails"
        label={T.translate("issueAttributes.locationDetails")}
        value={issue.locationDetails || ""}
        onChange={newValue => {
          handleChange({
            locationDetails: newValue,
          });
        }}
        showDisabledReason={!viewOnly}
        validator={text => {
          try {
            validationSchema.validateSync(text);
          } catch (error: any) {
            return error.message;
          }
        }}
        disabled={isDisabled}
        required={required}
      />
    </div>
  );
};
